import { Button } from '@mantine/core';
import { FC } from 'react';

import { TaskModalMode } from '@/models/TaskModalMode.ts';

import { useTaskFormStore } from '@/stores/taskFormStore.ts';
import { useTaskViewStore } from '@/stores/taskViewStore.ts';

import { triggerFormSubmit } from '@/utils/formUtils.ts';

const TaskModalFooter: FC = () => {
    const mode = useTaskViewStore((state) => state.task_modal_mode);
    const onCloseModal = useTaskViewStore((state) => state.onCloseModal);
    const is_valid = useTaskFormStore((state) => state.is_valid);
    const is_submitting = useTaskFormStore((state) => state.is_submitting);

    return (
        <div className="flex w-full justify-end gap-2">
            {mode === TaskModalMode.DETAILS ? (
                <Button
                    classNames={{ label: 'overflow-visible' }}
                    onClick={() => useTaskViewStore.setState({ task_modal_mode: TaskModalMode.EDITOR })}
                >
                    Aufgabe editieren
                </Button>
            ) : (
                <div className="flex w-full justify-between">
                    <Button variant="outline" onClick={onCloseModal}>
                        Abbrechen
                    </Button>
                    <Button
                        disabled={!is_valid}
                        classNames={{ label: 'overflow-visible' }}
                        onClick={triggerFormSubmit}
                        loading={is_submitting}
                    >
                        Speichern
                    </Button>
                </div>
            )}
        </div>
    );
};

export default TaskModalFooter;
